<template>
  <div class="about">
    <div class="margin1">
      <button 
        class="flexccc navicon large newfont margin-tb radius border1"
        @click="$emit('Navigate','')"
      >
        <span class="material-icons big">home</span>
      </button>
    </div>

    <Grid1x1
      class="flex centercenter">
      <div class="flex centercenter col2">
        <h1 class="newfont huge mt-0">About Us</h1>
      </div>
    </Grid1x1>

    <Grid1x1
      :gridStyles="grid2Styles">
      <div class="col1 pad">
        <div class="img1"></div>
      </div>
      <div class="flex centercenter col2">
        <h1 class="title2 newfont">We want to understand your business needs</h1>
      </div>
    </Grid1x1>

    <Grid1x1
      :gridStyles="grid1Styles"
      class="img4"
    >
      <h1 class="title1 newfont">
        We are a new company trying to pave an innovative way to help businesses reach their full potential through software
      </h1>
    </Grid1x1>

    <Grid1x1
      :gridStyles="grid2Styles">
      <div class="col1 pad">
        <div class="img3"></div>
      </div>
      <div class="flex centercenter col2">
        <h1 class="title2 newfont">Maximize your potential with software made to make you powerful</h1>
      </div>
    </Grid1x1>

    <Grid1x1
      class="img5"
      :gridStyles="grid4Styles">
      <h1 class="title1 newfont">
        We use proprietary technology to simplify and dramatically increase the speed of software delivery
      </h1>
    </Grid1x1>

    <Grid1x1
      :gridStyles="grid2Styles">
      <div class="flex centercenter col1">
        <h1 class="title2 newfont">We want to provide high quality services and value to help you make money</h1>
      </div>
      <div class="img2 col2"></div>
    </Grid1x1>

    <Grid1x1
      class="grid3Styles"
      >
      <img class="img-lg" src="../assets/iStock-1162000526.jpg" />
    </Grid1x1>

    <Grid1x1
      class="img6 together"
    >
      <h1 class="newfont big endtext fadedgreen">
        Lets Do This
      </h1>
      <h1 class="newfont big endtext fadedgreen">
        Together
      </h1>
    </Grid1x1>

    <Grid2x1 class="noborder">
      <div class="flexrcc">
        <button 
          class="flexccc navicon large pad-lr newfont margin-tb radius border1"
          @click="Scroll(0,0)" 
        >
          <span class="material-icons big">arrow_upward</span>To Top
        </button>
      </div>
      <div class="flexrcc">
        <button 
          class="flexccc navicon large pad-lr newfont margin-tb radius border1"
          @click="$emit('Navigate','')"
        >
          <span class="material-icons big">home</span>Home
        </button>
      </div>
    </Grid2x1>



    <Footer 
      copywrite="Composer Software 2022" 
    />

  </div>
</template>

<script>
//import Dropdowns from '@/components/Dropdowns.vue'

import Grid1x1 from '@/components/1x1grid.vue';
import Grid2x1 from '@/components/2x1grid.vue';
import Footer from '@/components/Footer.vue';
export default {
  name:'About',
  components:{
    Grid1x1,
    Grid2x1,
    Footer
  },
  props:{},
  data(){
    return {
      grid1Styles:{
        backgroundColor:"navy",
        minHeight:"45vh",
        display:"flex",
        alignItems:"center",
        justifyContent:"left",
        border:"none"
      },
      grid4Styles:{
        backgroundColor:"navy",
        height:"45vh",
        display:"flex",
        alignItems:"center",
        border:"none",
        justifyContent:"right"
      },
      grid2Styles:{
        backgroundColor:"white",
        justifyContent:"left",
        border:"none",
        overflow:"hidden",
        gridTemplateColumns:"repeat(10, 1fr)",
        minHeight:"500px"
      },
      img1CtnStyles:{
        gridColumn:"1 / 6"
      }
    }
  },
  methods:{
    Scroll(x,y){
      window.scrollTo(x,y);
    } 
  },
  created(){}
}
</script>

<style scoped>
.title1 {
  color:white;
  font-size:3em;
  text-align:left;
  width: 35%;
  margin-left: 5%;
}

.title2 {
  color:black;
  font-size:4em;
  text-align:left;
  padding:12%;
}

.newfont {
  font-family:'Bodoni Elegant Regular';
  font-weight:100;
}
.img1{
  background-image:url("../assets/iStock-881484382.jpg");
  background-color: #ffffff; /* Used if the image is unavailable */
  height: 420px; /* You must set a specified height */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
.img2{
  background-image: url("../assets/iStock-1165051903.jpg");
  grid-column:1 / 6;
  background-color: #ffffff; /* Used if the image is unavailable */
  height: 500px; /* You must set a specified height */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
.img3{
  background-image: url("../assets/iStock-143177617.jpg");
  grid-column:1 / 6;
  background-color: #cccccc; /* Used if the image is unavailable */
  height: 500px; /* You must set a specified height */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
.img4{
  background-image: url("../assets/iStock-1148764915.jpg");
  grid-column:1 / 6;
  background-color: #cccccc; /* Used if the image is unavailable */
  height: 500px; /* You must set a specified height */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
.img5{
  background-image: url("../assets/iStock-1058262630.jpg");
  grid-column:1 / 6;
  background-color: #cccccc; /* Used if the image is unavailable */
  height: 500px; /* You must set a specified height */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}

.img6{
  background-image: url("../assets/iStock-814320218.jpg");
  grid-column:1 / 6;
  background-color: #cccccc; /* Used if the image is unavailable */
  height: 500px; /* You must set a specified height */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}

.col1 {
  grid-column: 1 / 6;
}
.col2 {
  grid-column: 6 / 11;
}
.large {
  font-size:2em;
}
.big {
  font-size:3em;
}
.huge {
  font-size:6em;
}
.flex {
  display:flex;
  border:none;
}
.centercenter {
  align-items:center;
  justify-content:center;
}
.img-lg {
  grid-column: 1 / 11;
  width:100%;
}

.grid3Styles {
  background-color:white;
  justify-content:left;
  border:none;
  overflow:hidden;
  grid-template-columns:repeat(10, 1fr);
  position:relative;
}
.together {
  min-height: 45vh;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  flex-direction: column;
}
.pad {
  padding:40px 45px;
}
.pad-lr {
  padding: 0px 15px;
}
.fadedgreen {
  background-color:#00a70ba8;
}
.endtext {
  padding: 0px 25px;
  color:white;
  margin:0;
  font-size:6em;
}
.mt-0 {
  margin-top:0;
}
.radius {
  border-radius:15px;
}
.margin-tb {
  margin: 10px 0px;
}
.flexrcc {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.flexccc {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.noborder {
  border:none;
}
.border1 {
  border: 8px solid black;
}
.margin1 {
  margin:10px 10px;
}
.navicon {
  cursor:pointer;
  transition: all 1s ease;
}

.navicon:hover {
  cursor:pointer;
  color:white;
  background-color:black;
}


@media only screen and (max-width: 1000px) {
  .title1 {
    color:white;
    font-size:2em;
    text-align:left;
    width: 35%;
    margin-left: 5%;
  }
  
  .title2 {
    color:black;
    font-size:3em;
    text-align:left;
    padding:12%;
  }
  .grid3Styles {
    background-color:white;
    justify-content:left;
    border:none;
    overflow:hidden;
    grid-template-columns:repeat(10, 1fr);
    position:relative;
  }
}

@media only screen and (max-width: 600px) {
  .col1 {
    grid-column: 1 / 11;
  }
  .col2 {
    grid-column: 1 / 11;
  }
  .pad {
    padding:0;
  }
  .title1 {
    width:75%;
    background-color:#00000075;
  }
  .huge {
    font-size:4em;
  }
  .big {
    font-size:2em;
  }
  .mt-0 {
    margin-top:25px;
  }
}
</style>
